import React, { useState, useEffect } from 'react';
import { Typography } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import axios from 'axios';
import { Loader } from '../UI/Loader';
import { IPlanPhoto } from '../../types/plans';

interface FileMetadataProps {
  file: IPlanPhoto & UploadFile;
  onChange?: (file: UploadFile) => void;
}

const formatFileSize = (sizeInBytes: number) => {
  if (sizeInBytes >= 1024 * 1000) {
    return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
  }
  return `${(sizeInBytes / 1024).toFixed(2)} KB`;
};

const getSizeStatus = (sizeInBytes: number) => {
  if (sizeInBytes >= 1024 * 400) {
    return 'danger';
  }
  return 'secondary';
};

export const FileMetadata: React.FC<FileMetadataProps> = ({ file, onChange }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchMetadata = async () => {
      if (file.size && file.type) return;

      const url = file.compressed?.url || file.url || file.preview;
      if (!url) {
        console.log('No URL available for file');
        return;
      }

      setLoading(true);
      try {
        const response = await axios.post('/api/image/metadata', { url });
        const size = response.data.size;
        const type = response.data.type;

        if (size || type) {
          file.size = size ? parseInt(size, 10) : undefined;
          file.type = type || undefined;
          onChange?.(file);
        }
      } catch (error) {
        console.error('Error fetching image metadata:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMetadata();
  }, [file]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div style={{ textAlign: 'left' }}>
      <Typography.Text style={{ display: 'block' }}>Original</Typography.Text>
      <Typography.Text type="secondary" style={{ display: 'block' }}>
        Type: {file.type || 'Unknown'}
      </Typography.Text>
      <Typography.Text
        type={file.size ? getSizeStatus(file.size) : 'secondary'}
        style={{ display: 'block' }}>
        Size: {file.size ? formatFileSize(file.size) : 'Unknown'}
      </Typography.Text>
      {file.compressed && (
        <>
          <Typography.Text style={{ display: 'block' }}>Compressed</Typography.Text>
          <Typography.Text type="secondary" style={{ display: 'block' }}>
            Type: {file.compressed.type || 'Unknown'}
          </Typography.Text>
          <Typography.Text
            type={file.compressed.size ? getSizeStatus(file.compressed.size) : 'secondary'}
            style={{ display: 'block' }}>
            Size: {file.compressed.size ? formatFileSize(file.compressed.size) : 'Unknown'}
          </Typography.Text>
        </>
      )}
    </div>
  );
};
